import { NgModule } from '@angular/core';
import { CommonModule, DatePipe } from '@angular/common';
import { PrivateRoutingModule } from './private-routing.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NzButtonModule } from 'ng-zorro-antd/button';
import { NzCheckboxModule } from 'ng-zorro-antd/checkbox';
import { NzDropDownModule } from 'ng-zorro-antd/dropdown';
import { NzFormModule } from 'ng-zorro-antd/form';
import { NzInputModule } from 'ng-zorro-antd/input';
import { NzLayoutModule } from 'ng-zorro-antd/layout';
import { NzSelectModule } from 'ng-zorro-antd/select';
import { PrivateContactsComponent } from './private-contacts/private-contacts.component';
import { PrivateSaleEventsPreviewComponent } from './private-sale-events-preview/private-sale-events-preview.component';
import { PrivateSaleEventDetailComponent } from './private-sale-event-detail/private-sale-event-detail.component';
import { NzAnchorModule } from 'ng-zorro-antd/anchor';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { NzCollapseModule } from 'ng-zorro-antd/collapse';
import { BookSlotModalComponent } from './modals/book-slot-modal/book-slot-modal.component';
import { NzSwitchModule } from 'ng-zorro-antd/switch';
import { BookSlotDrawerComponent } from './drawers/book-slot-drawer/book-slot-drawer.component';
import { QrCodeModule } from 'ng-qrcode';
import { QrCodeDrawerComponent } from './drawers/qr-code-drawer/qr-code-drawer.component';
import { PrivateMyReservationsComponent } from './private-my-reservations/private-my-reservations.component';
import { NzTabsModule } from 'ng-zorro-antd/tabs';
import { NzPopoverModule } from 'ng-zorro-antd/popover';
import { LottieModule,LottieCacheModule } from 'ngx-lottie';
import player from 'lottie-web';
import { InstructionsModalComponent } from './modals/instructions-modal/instructions-modal.component';
import { InstructionsDrawerComponent } from './drawers/instructions-drawer/instructions-drawer.component';
import { QrCodeModalComponent } from './modals/qr-code-modal/qr-code-modal.component';
import { NzBadgeModule } from 'ng-zorro-antd/badge';
import { NzTagModule } from 'ng-zorro-antd/tag';
import { SendEmailInviteModalComponent } from './modals/send-email-invite-modal/send-email-invite-modal.component';
import { InviteFriendsDrawerComponent } from './drawers/invite-friends-drawer/invite-friends-drawer.component';
import { InviteFriendsModalComponent } from './modals/invite-friends-modal/invite-friends-modal.component';
import { BaseSaleEventDetailBannerComponent } from './private-sale-event-detail/base-sale-event-detail-banner/base-sale-event-detail-banner.component';
import { AdvancedSaleEventDetailBannerComponent } from './private-sale-event-detail/advanced-sale-event-detail-banner/advanced-sale-event-detail-banner.component';
import { BannerSlideComponent } from './private-sale-events-preview/banner-slide/banner-slide.component';
import { PrivateUserProfileComponent } from './private-user-profile/private-user-profile.component';
import { NzDatePickerModule } from 'ng-zorro-antd/date-picker';
import { ShowPolicyPreviewModalComponent } from './modals/show-policy-preview-modal/show-policy-preview-modal.component';
import { ShowPolicyPreviewDrawerComponent } from './drawers/show-policy-preview-drawer/show-policy-preview-drawer.component';
import { MatExpansionModule } from '@angular/material/expansion';
import { PrivateInviteFriendsDrawerComponent } from './drawers/private-invite-friends-drawer/private-invite-friends-drawer.component';
import { PrivateInviteFriendsModalComponent } from './modals/private-invite-friends-modal/private-invite-friends-modal.component';
import { NzNotificationModule } from 'ng-zorro-antd/notification';
import { PurpleEditImageModule, PurpleEditTextModule, PurpleGeneralDirectiveModule, PurplePipeModule, PurpleSelectModule } from 'purple-lib';
import { PurpleProjectWidgetsModule } from 'src/purple-widgets/purple-project-widgets.module';
import { SwiperModule } from 'swiper/angular';

export function playerFactory() {
  return player;
}

@NgModule({
  declarations: [PrivateContactsComponent, PrivateSaleEventsPreviewComponent, PrivateSaleEventDetailComponent, BookSlotModalComponent, SendEmailInviteModalComponent,InviteFriendsDrawerComponent, PrivateInviteFriendsModalComponent,
    BaseSaleEventDetailBannerComponent, AdvancedSaleEventDetailBannerComponent, BookSlotDrawerComponent, QrCodeDrawerComponent, PrivateMyReservationsComponent, InstructionsModalComponent,  ShowPolicyPreviewDrawerComponent,
    InstructionsDrawerComponent, QrCodeModalComponent, InviteFriendsModalComponent, BannerSlideComponent, PrivateUserProfileComponent,  ShowPolicyPreviewModalComponent, PrivateInviteFriendsDrawerComponent],
  imports: [
    PrivateRoutingModule,
    CommonModule,
    FormsModule,
    NzButtonModule,
    NzCheckboxModule,
    NzFormModule,
    NzInputModule,
    NzSelectModule,
    ReactiveFormsModule,
    NzLayoutModule,
    PurplePipeModule,
    NzDropDownModule,
    PurpleGeneralDirectiveModule,
    PurpleEditImageModule,
    PurpleEditTextModule,
    NzButtonModule,
    SwiperModule,
    NzAnchorModule,
    NzIconModule,
    NzCollapseModule,
    NzSwitchModule,
    QrCodeModule,
    NzTabsModule,
    NzPopoverModule,
    LottieModule.forRoot({ player: playerFactory }),
    LottieCacheModule.forRoot(),
    NzBadgeModule,
    NzDatePickerModule,
    PurpleSelectModule,
    MatExpansionModule,
    NzTagModule,
    NzNotificationModule,
    PurplePipeModule,
    PurpleProjectWidgetsModule
  ],
  providers: [DatePipe]
})
export class PrivateModule { }
